import React from 'react'
import PropTypes from 'prop-types'
import * as Sentry from '@sentry/browser'
import ErrorFallback from '@components/error_fallback'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      hasError: false,
    }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }

  componentDidCatch(error, info) {
    Sentry.captureException(error, { extra: info })
    console.error(error, { extra: info })
  }

  render() {
    const { children } = this.props
    const { hasError } = this.state
    if (hasError) {
      return <ErrorFallback />
    }
    return children
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
}

export default ErrorBoundary
